/**
 * Combobox add-value — "Add" on a SeeMe combobox keeps the typed text as the value.
 *
 * For a field that offers values already on file but also takes a new one, such
 * as a seller email or phone on the seller listing terms form
 * (`templates/acqs/_listing_contact_pick.html`). The combobox is the standard
 * markup with the "Add new" footer, plus two attributes on the container:
 *
 *   <div class="dropdown typeahead" data-combobox data-combobox-add-value="email"
 *        data-combobox-placeholder="Choose or type an email">
 *     ... <div data-combobox-add-error hidden></div> under the search input
 *     ... the Add item carries data-dropdown-keep-open, so a refused value leaves
 *         the menu open on its message; a kept one closes it through the option click
 *
 * combobox:add → check the typed text against the attribute's kind ("email": a
 * name@domain.tld shape; "phone": at least ten digits, the server's rule), show
 * the problem under the search box when it fails, else append an option for it
 * (or reuse a matching one) and click it, so combobox.js sets the trigger label
 * and the hidden input as it does for any pick. The server validates again.
 *
 * Clearing is SeeMe's data-combobox-clearable X, which restores
 * data-combobox-placeholder itself.
 */
(function () {
    'use strict';

    var findIn = window._cc.findIn;

    var CHECKS = {
        email: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? '' : 'Enter a full email address, like name@example.com.'; },
        phone: function (v) { return v.replace(/\D/g, '').length >= 10 ? '' : 'Enter a phone number with area code.'; }
    };

    function showError(combobox, message) {
        var el = findIn(combobox, '[data-combobox-add-error]');
        if (!el) return;
        el.textContent = message;
        el.hidden = !message;
    }

    document.addEventListener('input', function (e) {
        if (!e.target.matches || !e.target.matches('[data-combobox-search]')) return;
        var combobox = e.target.closest('[data-combobox-add-value]');
        if (combobox) showError(combobox, '');
    });

    document.addEventListener('combobox:add', function (e) {
        var combobox = e.target.closest('[data-combobox-add-value]');
        if (!combobox) return;
        var query = (e.detail && e.detail.query || '').trim();
        if (!query) return;
        var check = CHECKS[combobox.getAttribute('data-combobox-add-value')];
        var problem = check ? check(query) : '';
        showError(combobox, problem);
        if (problem) return;
        var list = findIn(combobox, '[data-combobox-list]');
        if (!list) return;
        var option = Array.prototype.find.call(
            list.querySelectorAll('[data-combobox-option]'),
            function (el) { return el.getAttribute('data-combobox-option').toLowerCase() === query.toLowerCase(); }
        );
        if (!option) {
            option = document.createElement('a');
            option.className = 'dropdown-item';
            option.href = '#';
            option.setAttribute('data-combobox-option', query);
            option.textContent = query;
            list.appendChild(option);
        }
        option.click();
    });
})();
